import React from "react";
import { NavLink } from "react-router-dom";

const Nav = () => {
  return (
    <>
      <nav class="navbar navbar-dark fixed-top py-4">
        <div class="container-fluid container">
          <a className="" href="/">
            <img className="logo1" src="img/Group 149.png" />
            <img className="logo2" src="img/logo2.png" />
          </a>
          <button
            class="navbar-toggler border-0"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasDarkNavbar"
            aria-controls="offcanvasDarkNavbar"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div
            class="offcanvas offcanvas-end"
            tabindex="-1"
            id="offcanvasDarkNavbar"
            aria-labelledby="offcanvasDarkNavbarLabel"
            style={{ backgroundColor: "#101010" }}
          >
            <div class="offcanvas-header">
              <h5 class="offcanvas-title" id="offcanvasDarkNavbarLabel">
                <img className="" src="img/Group 149.png" width="80px" />
              </h5>
              <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div class="offcanvas-body pt-0">
              <ul class="navbar-nav justify-content-end flex-grow-1 pe-3">
                <li class="nav-item">
                  <NavLink
                    end
                    to="/"
                    className={({ isActive }) =>
                      isActive ? "text-white nav-link" : "nav-link"
                    }
                  >
                    HOME
                  </NavLink>
                </li>
                <li class="nav-item">
                  <NavLink
                    end
                    to="/about"
                    className={({ isActive }) =>
                      isActive ? "text-white nav-link" : "nav-link"
                    }
                  >
                    ABOUT US
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    end
                    to="/services"
                    className={({ isActive }) =>
                      isActive ? "text-white nav-link" : "nav-link"
                    }
                  >
                    SERVICES
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    end
                    to="/portfolio"
                    className={({ isActive }) =>
                      isActive ? "text-white nav-link" : "nav-link"
                    }
                  >
                    PORTFOLIO
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    end
                    to="/technologies"
                    className={({ isActive }) =>
                      isActive ? "text-white nav-link" : "nav-link"
                    }
                  >
                    TECHNOLOGY STACK
                  </NavLink>
                </li>
                <li className="nav-item">
                  <NavLink
                    end
                    to="/contact"
                    className={({ isActive }) =>
                      isActive ? "active_menu nav-link" : "nav-link"
                    }
                  >
                    CONTACT US
                  </NavLink>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Nav;
